import en from "./en";

export default {
  ...en,
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "Inicio",
  metaTitleProducts: "Productos",
  metaTitleProductDetail: "Detalle del producto",
  metaTitleCustomService: "Servicio personalizado",
  metaTitleSolutions: "Soluciones",
  metaTitleAbout: "Perfil de la empresa",
  metaTitleContact: "Contáctanos",
  metaTitleBlog: "Blog",
  metaTitleLogin: "Iniciar sesión",
  metaTitleAdmin: "Panel de administración",
  metaTitleSystemSetup: "Configuración del sistema",
  authLogin: {
    ...en.authLogin,
    welcomeBack: "Bienvenido de nuevo",
    brandIntro: "Inicia sesión para continuar con la compra de productos de yoga y fitness.",
    brandBullet1: "Flujo RFQ rápido",
    brandBullet2: "Seguimiento de productos y pedidos",
    brandBullet3: "Soporte para cuentas B2B",
    accountLogin: "Iniciar sesión",
    createAccount: "Crear cuenta",
    recoverPassword: "Recuperar contraseña",
    registrationComplete: "Registro completado",
    passwordUpdated: "Contraseña actualizada",
    loginDesc: "Usa tu nombre de usuario o correo y contraseña para continuar.",
    registerDesc: "Crea tu cuenta con nombre de usuario, verificación por correo y captcha.",
    forgotDesc: "Ingresa el correo de tu cuenta para recibir un código de restablecimiento y definir una nueva contraseña.",
    registerSuccessDesc: "Tu cuenta se creó correctamente. Volveremos automáticamente a la pantalla de inicio de sesión.",
    resetSuccessDesc: "Tu contraseña se actualizó correctamente. Volveremos automáticamente a la pantalla de inicio de sesión.",
    redirectHintPrefix: "La página volverá al inicio de sesión en",
    redirectHintSuffix: ".",
    seconds: "segundos",
    loginNow: "Iniciar sesión ahora",
    username: "Nombre de usuario",
    usernamePlaceholder: "Al menos 3 caracteres, por ejemplo loya_buyer",
    usernameHelp: "El nombre de usuario debe tener al menos 3 caracteres, no usar palabras reservadas y solo puede incluir letras, números, guiones bajos y guiones medios.",
    usernameExistsHint: "Este nombre de usuario ya está registrado. Inicia sesión directamente o elige otro.",
    usernameExists: "El nombre de usuario ya existe. Elige otro o inicia sesión directamente.",
    usernameExistsAction: "El usuario existe, ir a iniciar sesión",
    usernameAlreadyRegistered: "Este nombre de usuario ya está registrado.",
    usernameAvailable: "Nombre de usuario disponible.",
    usernameVerifyFailed: "No se puede verificar el nombre de usuario ahora. Inténtalo de nuevo.",
    checkingUsername: "Comprobando disponibilidad del nombre de usuario...",
    email: "Correo electrónico",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "Ingresa el correo que quieres usar para recibir el código de verificación.",
    emailExistsHint: "Este correo ya está registrado. Inicia sesión directamente o usa otro correo.",
    emailExists: "El correo ya existe. Usa otro correo o ve a iniciar sesión.",
    emailExistsAction: "El correo existe, ir a iniciar sesión",
    emailAlreadyRegistered: "Este correo ya está registrado.",
    emailAvailable: "Correo disponible.",
    emailVerifyFailed: "No se puede verificar el correo ahora. Inténtalo de nuevo.",
    checkingEmail: "Comprobando disponibilidad del correo...",
    usernameOrEmail: "Usuario o correo",
    usernameOrEmailPlaceholder: "usuario o your@email.com",
    forgotEmailHint: "Ingresa el correo vinculado a tu cuenta para que podamos enviar un código de restablecimiento.",
    password: "Contraseña",
    passwordPlaceholder: "Ingresa la contraseña",
    confirmPassword: "Confirmar contraseña",
    confirmPasswordPlaceholder: "Vuelve a ingresar la contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    confirmNewPasswordPlaceholder: "Vuelve a ingresar la nueva contraseña",
    nickname: "Apodo",
    nicknamePlaceholder: "Opcional, para mostrar",
    captcha: "Captcha",
    registerCaptcha: "Captcha de registro",
    resetCaptcha: "Captcha de restablecimiento",
    refreshCaptcha: "Actualizar captcha",
    load: "Cargar",
    forgotCaptchaHint: "Completa primero el captcha y luego solicita el código de restablecimiento. Después de enviarlo, se cargará automáticamente un nuevo captcha para el paso final.",
    registerCaptchaHint: "Completa primero el captcha y luego solicita el código de verificación por correo.",
    registerStepHint: "Primero completa usuario, contraseña, confirmación y un correo válido. Luego aparecerá la sección de captcha y código por correo.",
    emailCode: "Código de correo",
    emailCodePlaceholder: "Código de 6 dígitos",
    resetCode: "Código de restablecimiento",
    resetCodePlaceholder: "Código de restablecimiento de 6 dígitos",
    sending: "Enviando...",
    resendIn: "Reenviar en",
    sendEmailCode: "Enviar código por correo",
    sendResetCode: "Enviar código de restablecimiento",
    signingIn: "Iniciando sesión...",
    login: "Iniciar sesión",
    updating: "Actualizando...",
    creating: "Creando...",
    resetPassword: "Restablecer contraseña",
    forgotRequirementHint: "La recuperación de contraseña requiere verificación por captcha y el código de restablecimiento enviado a tu correo.",
    registerRequirementHint: "El registro requiere el código enviado a tu bandeja de entrada.",
    captchaRefreshHint: "Si el captcha es difícil de leer, haz clic en la imagen de la derecha para actualizarlo.",
    switchToLogin: "¿Ya tienes cuenta? Inicia sesión ahora",
    switchToRegister: "¿Aún no tienes cuenta? Regístrate ahora",
    backToLogin: "Volver al inicio de sesión",
    forgotPassword: "¿Olvidaste tu contraseña?",
    usernameRequired: "Ingresa un nombre de usuario de al menos 3 caracteres.",
    usernameMin: "El nombre de usuario debe tener al menos 3 caracteres.",
    usernameMax: "El nombre de usuario debe tener 24 caracteres o menos.",
    usernamePattern: "El nombre de usuario solo puede contener letras, números, guiones bajos y guiones medios.",
    usernameReserved: "Este nombre de usuario está reservado. Elige otro.",
    usernameFormatOk: "El formato del nombre de usuario es válido.",
    emailRequired: "Ingresa un correo electrónico.",
    emailInvalid: "Ingresa un correo electrónico válido.",
    emailFormatOk: "El formato del correo es válido.",
    emailProviderHint: "Usa un proveedor de correo común cuando sea posible, como Gmail, Outlook, QQ Mail, 163, 126 o Foxmail.",
    didYouMean: "Quisiste decir",
    passwordMin: "La contraseña debe tener al menos 6 caracteres.",
    newPasswordMin: "La nueva contraseña debe tener al menos 6 caracteres.",
    confirmPasswordRequired: "Ingresa la contraseña de confirmación.",
    passwordMatch: "Las contraseñas coinciden.",
    passwordMismatch: "Las dos contraseñas no coinciden.",
    emailCodeRequired: "Ingresa el código de verificación por correo.",
    resetCodeRequired: "Ingresa el código de restablecimiento enviado a tu correo.",
    captchaRequired: "Ingresa el código captcha.",
    registerPrerequisitesError: "Completa usuario, contraseña, confirmación y un correo válido antes de solicitar el código por correo.",
    enterCaptchaBeforeEmailCode: "Ingresa el captcha antes de solicitar el código de verificación por correo.",
    enterCaptchaBeforeResetCode: "Ingresa el captcha antes de solicitar el código de restablecimiento de contraseña.",
    sendEmailCodeFailed: "No se pudo enviar el código de verificación por correo. Inténtalo de nuevo.",
    emailCodeSent: "El código de verificación por correo ha sido enviado.",
    registerFailed: "Error al registrarse",
    resetFailed: "Error al restablecer la contraseña",
    loginFailed: "Error de inicio de sesión",
    registerSuccessNotice: "Registro exitoso. Volviendo a la pantalla de inicio de sesión en unos 4 segundos.",
    resetSuccessNotice: "Contraseña restablecida correctamente. Volviendo a la pantalla de inicio de sesión en unos 1.5 segundos.",
    loginTokenMissing: "Falta el token de inicio de sesión",
    profileLoadFailed: "No se pudo cargar el perfil de la cuenta",
    loginSuccessAdmin: "Inicio de sesión exitoso. Redirigiendo...",
    loginSuccessStorefront: "Inicio de sesión exitoso. Redirigiendo a la tienda...",
    loginServiceUnavailable: "El servicio de inicio de sesión no está disponible temporalmente. Inténtalo de nuevo en unos momentos.",
    accountNotFound: "Cuenta no encontrada. Verifica tu nombre de usuario o correo.",
    passwordIncorrect: "Contraseña incorrecta. Inténtalo de nuevo.",
    registrationNotOpen: "El inicio de sesión y el registro están cerrados actualmente.",
    accountRestricted: "Esta cuenta tiene acceso restringido. Contacta al administrador.",
    captchaExpired: "El captcha ha expirado. Recarga la página y vuelve a intentarlo.",
    captchaIncorrect: "El código captcha es incorrecto. Inténtalo de nuevo.",
    passwordRequired: "Ingresa una contraseña.",
    emailCodeSentInbox: "El código de verificación se ha enviado. Revisa tu bandeja de entrada.",
    previewCodeCurrentEnv: "Código de vista previa del entorno actual",
    previewCodeDevelopment: "Código de vista previa de desarrollo",
    previewCodeGenerated: "El código de verificación se ha generado. Este entorno usa un código de vista previa.",
    previewCodeContinueRegistration: "Ingresa este código de 6 dígitos para continuar el registro.",
    tooManyRequests: "Demasiadas solicitudes. Inténtalo de nuevo más tarde.",
    smtpConfigRetry: "No se pudo enviar el correo. Verifica la configuración SMTP y vuelve a intentarlo.",
    emailServiceNotConfigured: "El servicio de correo no está configurado. Contacta al administrador.",
    requestFailed: "La solicitud falló. Inténtalo de nuevo o contacta a soporte.",
    orContinueWith: "O continuar con",
    googleAuthorizing: "Autorizando cuenta de Google...",
    googleFallbackAction: "Continuar con Google",
    googleAuthFailed: "Autenticación con Google fallida",
    googleAuthOffline: "El inicio de sesión con Google no está disponible sin conexión. Conectáte a internet o usa usuario y contraseña.",
    googleAuthTimeout: "La verificación de Google expiró. Inténtalo de nuevo. Si sigue fallando, pide al administrador que revise el acceso a la red del servidor.",
    googleAuthNetworkError: "La verificación de Google falló por error de red en el servidor. Contacta al administrador.",
    googleRegisterSuccess: "Cuenta de Google vinculada correctamente. Redirigiendo a la tienda...",
    googleCreateAccountTitle: "Completa tu registro con Google",
    googleCreateAccountDesc: "Google verificó tu correo. Crea una contraseña para crear tu cuenta de cliente y finalizar el inicio de sesión.",
    googleCreateAccountHint: "No existe una cuenta para este correo de Google. Crea una contraseña para crear tu cuenta de cliente.",
    googleLinkedEmailHint: "Este correo verificado por Google se usará para crear tu cuenta de cliente.",
    googleCreatePasswordHint: "Define y confirma una contraseña. La nueva cuenta de cliente usará tu correo verificado por Google."
  },

  // --- storefront ---
  navHome: "Inicio",
  navProducts: "Productos",
  navCustomization: "Servicio personalizado",
  navSolutions: "Soluciones",
  navAbout: "Perfil de la empresa",
  navContact: "Contáctanos",

  navYogaMats: "Esterillas de yoga",
  navYogaBlocks: "Bloques de yoga",
  navYogaStraps: "Correas de yoga",
  navResistanceBands: "Bandas de resistencia",
  navPilatesRings: "Aros de pilates",
  navFoamRollers: "Rodillos de espuma",
  navOemPrivateLabel: "Servicio personalizado",
  navSolutionsControl: "Control de calidad",
  navCompanyProfile: "Perfil de la empresa",
  navContactUs: "Contáctanos",
  navBlog: "Blog",

  btnContactUs: "Contáctanos",
  btnLogin: "Iniciar sesión",
  btnAccount: "Cuenta",
  btnQuote: "Solicitar cotización",
  btnCurrency: "Moneda",
  btnLanguage: "Idioma",

  seeAllCategories: "Ver todas las categorías",
  productDetailReady: "Listo para marca privada",
  productDetailQuote: "Cotización bajo solicitud",
  productDetailViewSpecs: "Ver especificaciones",
  productDetailRequestQuote: "Solicitar cotización",
  pdLoadErrorProductDetail: "Error al cargar el detalle del producto",
  pdLoadErrorRelatedProducts: "Error al cargar productos relacionados",
  pdLoadErrorStorefrontConfig: "Error al cargar la configuración de la tienda",
  pdLoading: "Cargando detalle del producto...",
  pdSampleDefaultMessage: "Comparte la política de muestras, el plazo de entrega y los detalles de cotización.",
  pdAttrProductName: "Nombre del producto",
  pdAttrModelNo: "Modelo",
  pdAttrCategory: "Categoría",
  pdAttrManufacturer: "Fabricante",
  pdLeadTimeOnRequest: "Plazo de entrega bajo consulta",
  pdLeadTimeUpTo: "Hasta {qty} piezas: {days} días",
  pdLeadTimeFrom: "{qty}+ piezas: {days} días",
  pdLeadTimeDaysOnly: "{days} días",
  pdContactForQuote: "Contacta para cotización",
  pdPerPiece: "{price} / pieza",
  pdAnonymousBuyer: "Comprador anónimo",
  pdReviewTipSignIn: "Inicia sesión como cliente para marcar como útil.",
  pdReviewTipSessionExpired: "La sesión expiró. Inicia sesión de nuevo.",
  pdReviewTipNoPermission: "La cuenta actual no puede marcar como útil.",
  pdReviewTipUpdateFailed: "No se pudo actualizar el estado de útil",
  pdSpecValues: "Valores",
  pdSpecRequired: "Obligatorio",
  pdSpecOptional: "Opcional",
  pdCapabilityCustomLogo: "Aplicación de logotipo personalizado",
  pdCapabilitySampleDev: "Desarrollo basado en muestras",
  pdCapabilityPackagingCoordination: "Coordinación de empaque",
  pdCapabilityExportFollowUp: "Seguimiento de envío de exportación",
  pdPackagingSellingUnit: "Unidad de venta",
  pdPackagingSingleItem: "Unidad individual",
  pdPackagingType: "Empaque",
  pdPackagingTypeFallback: "Bolsa OPP / caja de exportación",
  pdPackagingLoadingAdvice: "Sugerencia de carga",
  pdPackagingLoadingAdviceFallback: "Según la estructura del pedido",
  pdPackagingLeadTime: "Plazo de entrega",
  pdMediaPhotoLabel: "Foto {index}",
  pdMediaVideoLabel: "Video",
  pdMediaAttributesLabel: "Atributos",
  pdPackagingPointPackaging: "Empaque: {value}",
  pdPackagingPointLoadingAdvice: "Sugerencia de carga: {value}",
  pdPackagingPointShippingPort: "Puerto de envío: {value} (negociable)",
  pdPackagingPointShippingPortNegotiable: "Puerto de envío: negociable",
  pdPackagingPointLeadTime: "Plazo de entrega: {value}",
  pdInquiryHello: "Hola, quiero consultar sobre:",
  pdInquiryProduct: "Producto: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "Nombre SKU: {value}",
  pdInquiryModel: "Modelo: {value}",
  pdInquiryQuantity: "Cantidad: {value}",
  pdEmailSubject: "Consulta: {sku} - {name}",
  pdInquirySubmitFailed: "No se puede enviar la consulta ahora.",
  pdSampleContactPerson: "Contacto: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "Empresa: {value}",
  pdSampleRequestedQuantity: "Cantidad solicitada: {value}",
  pdSampleSelectorQuantity: "Selector de cantidad en página: {value}",
  pdVariationLabel: "Opción",
  pdVariationInquiryIntro: "Hola, me gustaría enviar una consulta para:",
  pdVariationInquiryQuoteLeadTime: "Comparte la cotización más reciente y el plazo de entrega.",
  pdVideoFallback: "No se pudo cargar el video. Intenta de nuevo o abre la fuente.",
  pdRetry: "Reintentar",
  pdOpenVideoUrl: "Abrir URL del video",
  pdProductAttributes: "Atributos del producto",
  pdMediaTabsAria: "Tipos de medios del producto",
  pdMediaTabPhotos: "Fotos",
  pdMediaTabVideo: "Video",
  pdMediaTabAttributes: "Atributos",
  pdInfoTabsAria: "Pestañas de información de detalle",
  pdInfoTabAttributes: "Atributos",
  pdInfoTabDescription: "Descripción",
  pdInfoTabSupplier: "Proveedor",
  pdInfoTabReviews: "Reseñas",
  pdKeyAttributes: "Atributos clave",
  pdPackagingShippingInfo: "Información de empaque y envío",
  pdProductDescription: "Descripción del producto",
  pdSupplierOverview: "Resumen del proveedor",
  pdSupplierOverviewHint: "El perfil de la empresa y FAQ se muestran debajo de las imágenes de detalle.",
  pdBuyerFeedback: "Opiniones de compradores",
  pdRepeatBuyer: "Comprador recurrente",
  pdReviewRatingAria: "Calificación {rating} de 5",
  pdReviewMetaColor: "color: {value}",
  pdReviewMetaColorFallback: "segundo",
  pdReviewUnavailable: "Este producto ya no está disponible",
  pdReviewHelpful: "Útil ({count})",
  pdNoReviews: "Aún no hay reseñas para este producto.",
  pdNoReviewsHint: "Contacta a nuestro equipo para referencias de pedidos o feedback de muestras.",
  pdTitleFallback: "Detalle del producto",
  pdCustomizable: "Personalizable",
  pdVariationCardAria: "Variaciones del producto",
  pdVariations: "Variaciones",
  pdSelectNow: "Seleccionar ahora",
  pdSelectOption: "Seleccionar opción",
  pdLadderPricingAria: "Precio escalonado",
  pdProductSpecifications: "Especificaciones del producto",
  pdSpecPrevAria: "Mostrar valor de especificación anterior",
  pdSpecNextAria: "Mostrar siguiente valor de especificación",
  pdSupplierCapability: "Capacidad de personalización del proveedor",
  pdGetFreeSample: "Obtener muestra gratis",
  pdWhatsAppInquiry: "Consulta por WhatsApp",
  pdEmailInquiry: "Consulta por correo",
  pdPackagingDelivery: "Empaque y entrega",
  pdProductVideo: "Video del producto",
  pdVideoOpenLink: "No se puede reproducir el video en el contexto actual.",
  pdSupplierDescriptions: "Descripciones del producto del proveedor",
  pdCompanyIntroduction: "Introducción de la empresa",
  pdNoCompanyIntroduction: "No hay introducción de empresa configurada.",
  pdFaq: "FAQ",
  pdNoFaq: "No hay FAQ configurada.",
  pdCloseVariationSelector: "Cerrar selector de variación",
  pdVariationSelectAndQty: "Seleccionar variaciones y cantidad",
  pdVariationStock: " / stock {count}",
  pdSelectedQuantity: "Cantidad seleccionada",
  pdSendInquiry: "Enviar consulta",
  pdChatNow: "Chatear ahora",
  pdOptionLabel: "Opción {index}",
  pdRelatedAria: "Productos relacionados",
  pdRelatedTitle: "Productos relacionados",
  pdRelatedSubtitle: "Más artículos que los compradores suelen adquirir juntos en esta categoría.",
  pdRelatedPrevAria: "Productos relacionados anteriores",
  pdRelatedNextAria: "Siguientes productos relacionados",
  pdSampleContactTitle: "Contáctanos",
  pdSampleContactDesc: "¿Tienes preguntas? Estamos encantados de ayudarte. Contáctanos por WhatsApp o correo para soporte de muestras.",
  pdSampleCloseAria: "Cerrar consulta de muestra",
  pdSampleSummaryProduct: "Producto",
  pdSampleSummaryQuantity: "Cantidad",
  pdFormFullName: "Nombre completo",
  pdFormFullNamePlaceholder: "Tu nombre",
  pdFormEmail: "Correo*",
  pdFormEmailPlaceholder: "Contactarte por correo",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "Contactarte por WhatsApp",
  pdFormCompany: "Nombre de tu empresa",
  pdFormCompanyPlaceholder: "Nombre de tu empresa",
  pdFormRequiredQuantity: "Cantidad requerida",
  pdFormRequiredQuantityPlaceholder: "Cantidad de muestra o prueba requerida",
  pdFormMessage: "Mensaje",
  pdFormMessagePlaceholder: "Describe brevemente los requisitos de tu producto",
  pdFormSending: "Enviando...",
  pdFormSendMessage: "Enviar mensaje",
  pdFormInquirySuccess: "Consulta enviada correctamente.",

  carouselLoadingTitle: "Cargando imágenes del banner",
  carouselLoadingBody:
    "Estamos preparando las imágenes principales de la página de inicio. Espera un momento mientras se cargan los recursos.",
  carouselPlaceholderTitle: "Las imágenes del banner se están preparando",
  carouselPlaceholderBody:
    "El carrusel de la página de inicio aparecerá aquí una vez que las imágenes estén listas.",

  // --- OEM / custom service ---
  oemHeroKicker: "Servicio personalizado",
  oemTitle:
    "Crea una línea de yoga personalizada con un flujo de producción claro",
  oemIntro:
    "Apoyamos a compradores internacionales con personalización de productos, desarrollo de empaques, seguimiento de muestras y ejecución de pedidos para las categorías de yoga y fitness ligero.",
  oemStartProject: "Inicia tu proyecto personalizado",
  oemBrowseProducts: "Ver productos base",
  oemVisualGuide: "Guía visual de personalización",
  oemVisualAlt: "Guía del proceso y opciones de personalización OEM",
  oemVisualPlaceholder:
    "No se encontró la imagen de personalización. Agrega tu archivo en frontend/public/assets/about/oem-customization-guide.jpg",
  oemCapabilityKicker: "Qué podemos personalizar",
  oemCapabilityTitle:
    "Desde la aplicación del logotipo hasta la ejecución completa del empaque",
  oemProjectBrief: "Resumen del proyecto",

  oemCapability1:
    "Impresión de logotipo personalizada, grabado en relieve y marcado láser para accesorios principales de yoga.",
  oemCapability2:
    "Ajustes de color, material, textura y tamaño según tu mercado objetivo.",
  oemCapability3:
    "Empaque listo para venta minorista, tarjetas insertas, etiquetas de codigo de barras y marcas de caja.",
  oemCapability4:
    "Desarrollo de paquetes combinados para sets de estudio, paquetes listos para Amazon y promociones de temporada.",

  oemProcess1Title: "Comparte tu idea",
  oemProcess1Body:
    "Envíanos los productos objetivo, archivos del logotipo, imágenes de referencia, expectativas de empaque y cantidad estimada.",
  oemProcess2Title: "Confirmar especificaciones y MOQ",
  oemProcess2Body:
    "Revisamos opciones de material, método de marca, puntos de cumplimiento, plazo de entrega y cantidad inicial viable.",
  oemProcess3Title: "Muestras y revisión",
  oemProcess3Body:
    "Organizamos muestras o maquetas, recopilamos tus comentarios y definimos el estándar de producción antes del anticipo.",
  oemProcess4Title: "Producción masiva e inspección",
  oemProcess4Body:
    "La producción sigue la muestra aprobada, con revisión del empaque y control de calidad antes del envío.",

  // --- news ---
  newsHeroKicker: "Actualizaciones del sector",
  newsTitle: "Noticias y actualizaciones",
  newsIntro:
    "Sigue nuestras últimas ideas de abastecimiento, novedades de lanzamiento de productos y actualizaciones de exportación para compradores de accesorios fitness.",
  newsSectionTitle:
    "Para anuncios de proyectos personalizados o avances de nuevas colecciones, contacta a nuestro equipo comercial para obtener el catálogo más reciente.",

  news1Title: "Se publica la guía de abastecimiento de primavera",
  news1Body:
    "Explora las últimas tendencias en yoga, pilates y productos de recuperación para la próxima temporada comercial.",
  news2Title: "Actualizaciones de empaques OEM",
  news2Body:
    "Ahora ofrecemos más opciones ecológicas de cajas, tarjetas insertas y empaques con código de barras para programas de marca privada.",
  news3Title: "Aviso sobre calendario de exportación",
  news3Body:
    "Los tiempos de producción y ventanas de envío se actualizan semanalmente para ayudar a los compradores a planificar mejor sus lanzamientos.",

  // --- contact ---
  contactHeroKicker: "Consulta comercial",
  contactTitle: "Contactar proveedor",
  contactIntro:
    "Cuéntanos tus requisitos de producto y mercado objetivo. Nuestro equipo responderá con detalles de cotización y tiempos de entrega.",
  contactFormTitle: "Enviar consulta",
  contactName: "Tu nombre",
  contactEmail: "Correo laboral",
  contactCompany: "Nombre de empresa",
  contactMessage: "Especificaciones del producto, cantidad y destino de envío",
  contactSubmit: "Enviar consulta",
  contactSent: "Mensaje enviado correctamente.",

  contactInfoTitle: "Oficina comercial",
  contactInfoEmail: "Correo",
  contactInfoPhone: "Teléfono",
  contactInfoHours: "Horario: Lun-Sáb, 09:00-18:00 (GMT+8)",
  contactInfoNote:
    "Canales recomendados: correo para cotizaciones formales, teléfono para urgencias de programación.",

  contactResponseTitle: "Tiempo promedio de respuesta",
  contactResponseDesc:
    "Dentro de 8 horas hábiles para solicitudes RFQ estándar.",
  contactDocsTitle: "Documentos disponibles",
  contactDocsDesc:
    "Factura comercial, lista de empaque y soporte de coordinación logística.",
  contactSampleTitle: "Servicio de muestras",
  contactSampleDesc:
    "Gestión rápida de muestras para proyectos OEM y marca privada.",

  // --- about ---
  aboutTitle: "Sobre LOYA SPORT",
  aboutIntro:
    "LOYA SPORT es un integrador de cadena de suministro de productos de yoga para compradores B2B globales.",
  aboutWhoWeAre: "Quiénes somos",
  aboutWhoWeAreDesc1:
    "Apoyamos a importadores, distribuidores, minoristas y marcas privadas coordinando abastecimiento, muestras, branding y seguimiento de embarques con socios de suministro verificados.",
  aboutWhoWeAreDesc2:
    "Nuestra fortaleza está en una comunicación práctica, el enfoque por categoría y un flujo de compra claro que ayuda a los clientes internacionales a avanzar más rápido.",

  aboutSupplyCapabilities: "Capacidades de suministro",
  aboutSupplyList1:
    "Coordinación de proveedores verificados para líneas de yoga y fitness ligero",
  aboutSupplyList2:
    "Revisión de calidad en múltiples etapas con fábricas asociadas",
  aboutSupplyList3: "Soporte para marca privada y empaque",
  aboutSupplyList4: "Soporte de suministro para mercados globales",

  aboutProductDev: "Desarrollo de producto",
  aboutProductDevDesc:
    "Ciclos rápidos de muestras y colaboración práctica de diseño para una salida al mercado más rápida.",
  aboutSupplyReliability: "Fiabilidad del suministro",
  aboutSupplyReliabilityDesc:
    "Abastecimiento estable de materiales y planificación de capacidad para mantener entregas puntuales en temporadas altas.",
  aboutTradeSupport: "Soporte comercial",
  aboutTradeSupportDesc:
    "Documentación, coordinación de envíos y servicio posventa para operaciones internacionales más fluidas.",

  aboutMission: "Nuestra misión",
  aboutMissionDesc:
    "Ayudar a marcas fitness y compradores minoristas a crecer mediante un abastecimiento confiable, control de calidad estricto y servicio posventa integral.",

  searchOverlayPlaceholder: "Buscar productos por nombre...",
  searchOverlaySubmitAria: "Enviar búsqueda",
  searchOverlaySubmitTitle: "Buscar",
  searchOverlayHintPrefix: "Pulsa",
  searchOverlayHintSuffix:
    "para ver todos los productos coincidentes, o elige un resultado rápido abajo.",
  searchOverlayCloseAria: "Cerrar búsqueda",
  searchOverlayQuickResults: "Resultados rápidos",
  searchOverlayQuickResultsAria: "Resultados rápidos de búsqueda",
  searchOverlayFallbackCategory: "Accesorios de yoga",
  searchOverlayHistory: "Historial de búsqueda",
  searchOverlayClear: "Limpiar",
  searchOverlayNoHistory: "Sin búsquedas recientes",
  searchOverlayRecommended: "Palabras clave recomendadas",
  searchOverlayFallbackKeyword: "Esterilla de yoga",

  blogHeroKicker: "Centro de contenido",
  blogHeroTitle: "Insights y guías de compra",
  blogSearchAria: "Buscar artículos",
  blogCategoryAria: "Categorías de artículos",
  blogFeaturedPlaceholder: "Insight destacado",
  blogPaginationAria: "Paginación del blog",
  blogCtaAria: "Llamado a la acción del blog",
  blogCtaDescription: "Nuestro equipo puede ofrecerte recomendaciones específicas y acompañamiento desde las muestras hasta la entrega en volumen.",
  blogCtaPrimary: "Contactar ahora",
  blogCtaSecondary: "Ver soluciones",
  contactInquiryGreeting: "Hola, me gustaría consultar sobre este producto:",
  contactInquiryProductPrefix: "Producto:",
  contactInquiryQuantity: "Cantidad:",
  contactInquiryDestinationPort: "Puerto de destino:",

  aboutHeroKicker: "Integrador de cadena de suministro",
  aboutHeroTitle:
    "Ayudamos a compradores internacionales a gestionar abastecimiento, coordinación de fábrica y entrega de exportación con un solo equipo comercial.",
  aboutHeroBody:
    "LOYA SPORT se posiciona como integrador de cadena de suministro para yoga, pilates y fitness ligero. No solo presentamos productos. Organizamos proveedores, muestras, empaque, seguimiento de calidad y preparación de embarque en un flujo de compra ejecutable para clientes internacionales.",
  aboutMetric1:
    "ventana única de proyecto para comunicación de producto, empaque y entrega",
  aboutMetric2:
    "recursos de fábrica coordinados bajo una sola estructura de abastecimiento y seguimiento",
  aboutMetric3:
    "flujo B2B diseñado para importadores, minoristas, distribuidores y compradores de marca privada",
  aboutPlaceholderNote:
    "Nuestro papel es reducir la comunicación fragmentada entre comprador, proveedor y equipos de ejecución de fábrica, para que los proyectos avancen con más claridad y menos puntos ciegos.",
  aboutHeroImageAlt:
    "Reunión de coordinación de cadena de suministro para compradores de exportación",
  aboutHeroCaption:
    "Desde la consulta hasta el embarque, coordinamos los detalles que normalmente quedan divididos entre agentes de compras, fábricas y contactos logísticos.",
  aboutOfficeImageAlt: "Edificio de oficinas de Loya Technology en Changsha",
  aboutOfficeCaption: "Oficina de Loya Technology en Changsha",
  aboutTeamImageAlt: "Nuestro equipo profesional en la oficina de Changsha",
  aboutFactoryImageAlt: "Línea de producción de esterillas de yoga y flujo de calidad",
  aboutFactoryCollageAlt: "Almacén de fábrica y detalles de producción",
  aboutWhatWeDoTitle: "Qué hacemos realmente",
  aboutWhatWeDoBody1:
    "Muchos compradores no necesitan solo un catálogo. Necesitan un socio que conecte los requisitos comerciales con la ejecución real de fábrica. Ahí es donde trabajamos. Coordinamos selección de proveedores, discusión de precios, muestreo de producto, ejecución de empaque, seguimiento de producción, alineación de inspecciones y preparación de exportación.",
  aboutWhatWeDoBody2:
    "En lugar de dejar detalles de producto, archivos de empaque, tiempos de entrega y cambios de pedido en contactos separados, centralizamos el proceso y mantenemos el proyecto avanzando con una ruta de comunicación responsable.",
  aboutBadge1: "Matching de proveedores",
  aboutBadge2: "Seguimiento de muestras",
  aboutBadge3: "Ejecución de empaque",
  aboutBadge4: "Preparación de embarque",
  aboutSideImageAlt: "Comunicación con comprador y revisión de proyecto",
  aboutIntegratedCapabilitiesTitle:
    "Capacidades integradas de cadena de suministro",
  aboutSideCaption:
    "Nos enfocamos en hacer la cadena de abastecimiento más fácil de gestionar para compradores internacionales que necesitan coordinación confiable más que actividad comercial aislada.",
  aboutCapabilityCard1Title: "Integración de red de proveedores",
  aboutCapabilityCard1Body:
    "Combinamos recursos de fábrica, conocimiento de categoría y controles de abastecimiento en un solo flujo orientado al comprador para que no tengas que coordinar múltiples partes por tu cuenta.",
  aboutCapabilityCard2Title: "Coordinación comercial y técnica",
  aboutCapabilityCard2Body:
    "Desde cotización, muestreo y detalles de empaque hasta confirmación de especificaciones y puntos de control de producción, mantenemos alineados el lado comercial y el de fábrica.",
  aboutCapabilityCard3Title: "Ejecución de pedidos de exportación",
  aboutCapabilityCard3Body:
    "Seguimos los pedidos a través de inspección, documentación, reserva y preparación de embarque para reducir brechas de comunicación y riesgo de entrega.",
  aboutOperatingModel1:
    "Abastecimiento por categoría y matching de fábrica según tu mercado objetivo y posicionamiento de precio.",
  aboutOperatingModel2:
    "Muestreo, revisión de especificaciones y coordinación de empaque antes de bloquear producción.",
  aboutOperatingModel3:
    "Seguimiento de producción, puntos de control de calidad y preparación de embarque en un solo flujo de proyecto.",
  aboutOperatingModel4:
    "Ventana de comunicación única para producto, empaque, documentación y avance de entrega.",
  aboutWhoWeServeTitle: "A quién servimos",
  aboutBuyerScenario1Title: "Para importadores y distribuidores",
  aboutBuyerScenario1Body:
    "Ayudamos a consolidar líneas de producto, comparar opciones de proveedores y construir un plan de reposición más estable entre categorías.",
  aboutBuyerScenario2Title: "Para cadenas minoristas y vendedores e-commerce",
  aboutBuyerScenario2Body:
    "Apoyamos surtidos listos para lanzamiento, empaque de marca privada y comunicación práctica para pedidos repetibles.",
  aboutBuyerScenario3Title: "Para marcas que expanden su línea",
  aboutBuyerScenario3Body:
    "Actuamos como capa de coordinación entre tu concepto, el lado de producción y la ejecución de exportación para que los equipos internos se muevan más rápido.",
  aboutWorkflowTitle: "Cómo estructuramos el flujo",
  aboutWorkflowStep1:
    "Recepción de requisitos y clarificación del producto objetivo",
  aboutWorkflowStep2:
    "Matching de proveedores, cotización y planificación de muestras",
  aboutWorkflowStep3:
    "Revisión de especificaciones, empaque y cumplimiento",
  aboutWorkflowStep4:
    "Seguimiento de producción, inspección y preparación de embarque",
  aboutWhyIntegratorTitle:
    "Por qué los compradores usan un integrador de cadena",
  aboutWhyIntegratorBody1:
    "Cuando el abastecimiento cruza múltiples proveedores, partners de empaque y cronogramas de embarque, el mayor riesgo no suele ser la primera cotización. Es la pérdida de alineación cuando el pedido ya está en marcha.",
  aboutWhyIntegratorList1:
    "Las especificaciones pueden desviarse entre cotización y producción.",
  aboutWhyIntegratorList2:
    "Los detalles de empaque y marca pueden retrasarse por comunicación fragmentada.",
  aboutWhyIntegratorList3:
    "La inspección, la documentación y la preparación de embarque pueden desconectarse de la promesa comercial original.",
  aboutWhyIntegratorBody2:
    "Nuestro valor es mantener esas partes conectadas. Trabajamos como capa de coordinación entre expectativas del comprador y ejecución del proveedor para que las decisiones queden documentadas, los tiempos se sigan y se reduzca el riesgo de traspaso.",
  aboutTalkToTeam: "Habla con nuestro equipo",
  aboutPositioningTitle: "Nuestro posicionamiento",
  aboutPositioningBody:
    "LOYA SPORT se posiciona como integrador de cadena para productos fitness orientados a exportación. Ayudamos a los clientes a comprar con coordinación más clara, mejor organización de proveedores y una ruta más manejable desde abastecimiento hasta embarque.",

  solutionsHeroKicker: "Soluciones",
  solutionsHeroTitle:
    "Elige la ruta de abastecimiento adecuada para tu tipo de comprador",
  solutionsHeroBody:
    "Diseñado como guía visual para ajuste por canal, escenario y planificación de programa de producto.",
  solutionsTalkToSales: "Hablar con ventas",
  solutionsBrowseProducts: "Explorar productos",
  solutionsHeroImageAlt:
    "Soluciones de abastecimiento B2B para compradores de yoga y fitness ligero",
  solutionsHeroBadgeTitle: "Encaje de solución",
  solutionsHeroBadgeBody: "Tipo de comprador + caso de uso + surtido",
  solutionsBuyerTypeTitle: "Soluciones por tipo de comprador",
  solutionsViewMatchingProducts: "Ver productos compatibles",
  solutionsScenarioPlansTitle: "Planes por escenario",
  solutionsProgramMixesTitle: "Mixes de programa recomendados",
  solutionsNextStepKicker: "Siguiente paso",
  solutionsNextStepTitle:
    "¿Necesitas un mix adaptado a tu mercado?",
  solutionsNextStepBody:
    "Comparte tu tipo de comprador, productos objetivo y mercado de destino. Te propondremos una ruta de surtido práctica.",
  solutionsRequestPlan: "Solicitar plan de solución",
  solutionsExploreOem: "Explorar soporte OEM",

  solutionsBuyerCard1Title: "Mayoristas",
  solutionsBuyerCard1Subtitle:
    "Construcción rápida de surtido para programas en volumen.",
  solutionsBuyerCard1Need1:
    "Necesitas suministro estable en volumen con menor riesgo de quiebre",
  solutionsBuyerCard1Need2:
    "Necesitas mezclas SKU listas por caja para acelerar reventa",
  solutionsBuyerCard1Need3:
    "Necesitas ciclos de recompra repetibles con lead time predecible",
  solutionsBuyerCard1Tag1: "Surtidos en volumen",
  solutionsBuyerCard1Tag2: "Packs listos por caja",
  solutionsBuyerCard1Tag3: "Reposición recurrente",

  solutionsBuyerCard2Title: "Minoristas",
  solutionsBuyerCard2Subtitle:
    "Packs listos para estantería y reposición estable.",
  solutionsBuyerCard2Need1:
    "Necesitas escalas de precio claras de entrada a premium",
  solutionsBuyerCard2Need2:
    "Necesitas empaque con código de barras para listar más rápido",
  solutionsBuyerCard2Need3:
    "Necesitas reposición confiable para artículos de alta rotación",
  solutionsBuyerCard2Tag1: "Packs minoristas",
  solutionsBuyerCard2Tag2: "Soporte de código de barras",
  solutionsBuyerCard2Tag3: "Mezclas listas para exhibición",

  solutionsBuyerCard3Title: "Marcas fitness",
  solutionsBuyerCard3Subtitle:
    "Programas de marca privada para expansión de marca.",
  solutionsBuyerCard3Need1:
    "Necesitas branding personalizado sin reconstruir toda la cadena",
  solutionsBuyerCard3Need2:
    "Necesitas estilos de empaque alineados al posicionamiento",
  solutionsBuyerCard3Need3:
    "Necesitas acelerar los tiempos de muestra a lanzamiento",
  solutionsBuyerCard3Tag1: "Aplicación de logo",
  solutionsBuyerCard3Tag2: "Empaque personalizado",
  solutionsBuyerCard3Tag3: "Extensión de línea",

  solutionsBuyerCard4Title: "Estudios de yoga",
  solutionsBuyerCard4Subtitle:
    "Kits de estudio, accesorios y combinaciones para clases.",
  solutionsBuyerCard4Need1:
    "Necesitas kits de inicio para nuevos miembros y clases de prueba",
  solutionsBuyerCard4Need2:
    "Necesitas accesorios durables para sesiones frecuentes",
  solutionsBuyerCard4Need3:
    "Necesitas precios de combinacion practicos para upselling",
  solutionsBuyerCard4Tag1: "Sets de inicio",
  solutionsBuyerCard4Tag2: "Accesorios de clase",
  solutionsBuyerCard4Tag3: "Kits de upgrade de membresía",

  solutionsBuyerCard5Title: "Vendedores de Amazon",
  solutionsBuyerCard5Subtitle:
    "Combinaciones y empaque listos para marketplace.",
  solutionsBuyerCard5Need1:
    "Necesitas estructura compacta de combinacion para controlar flete",
  solutionsBuyerCard5Need2:
    "Necesitas combinaciones orientadas a conversión",
  solutionsBuyerCard5Need3:
    "Necesitas calidad de empaque que reduzca devoluciones",
  solutionsBuyerCard5Tag1: "Combinaciones compactas",
  solutionsBuyerCard5Tag2: "Empaque listo para listing",
  solutionsBuyerCard5Tag3: "Lanzamientos de baja fricción",

  solutionsBuyerCard6Title: "Negocios de e-commerce",
  solutionsBuyerCard6Subtitle:
    "Productos visual-first para ventas online repetidas.",
  solutionsBuyerCard6Need1:
    "Necesitas SKUs hero que rindan en anuncios y tráfico social",
  solutionsBuyerCard6Need2:
    "Necesitas combinaciones flexibles para aumentar AOV",
  solutionsBuyerCard6Need3:
    "Necesitas renovar catálogo rápido para campañas estacionales",
  solutionsBuyerCard6Tag1: "Productos hero",
  solutionsBuyerCard6Tag2: "Logica de combinaciones",
  solutionsBuyerCard6Tag3: "Refresh rápido de catálogo",

  solutionsScenario1Title: "Sets de inicio para estudio",
  solutionsScenario1Body:
    "Combinaciones de yoga listas para lanzamiento en clases, pruebas y membresias.",
  solutionsScenario2Title: "Zonas de recuperación y masaje",
  solutionsScenario2Body:
    "Herramientas de masaje, rodillos y accesorios de recuperación para espacios de gimnasio.",
  solutionsScenario3Title: "Programas de exhibicion minorista",
  solutionsScenario3Body:
    "Surtidos equilibrados con empaque adecuado para presentación en estantería.",
  solutionsScenario4Title: "Ofertas de combinaciones online",
  solutionsScenario4Body:
    "Kits compactos diseñados para páginas de producto enfocadas en conversión.",

  solutionsProgram1Title: "Mix de lanzamiento para estudio",
  solutionsProgram1Body:
    "Un surtido inicial claro para negocios de yoga basados en clases.",
  solutionsProgram1Item1: "Esterillas de yoga",
  solutionsProgram1Item2: "Bloques y correas",
  solutionsProgram1Item3: "Accesorios de masaje",
  solutionsProgram1SuitedFor: "Estudios / entrenadores",

  solutionsProgram2Title: "Programa para estanteria minorista",
  solutionsProgram2Body:
    "Familia de productos equilibrada para tiendas que necesitan escalas de precio claras y pedidos repetidos.",
  solutionsProgram2Item1: "Esterillas núcleo",
  solutionsProgram2Item2: "Accesorios de pilates",
  solutionsProgram2Item3: "Herramientas de recuperación de impulso",
  solutionsProgram2SuitedFor: "Minoristas / distribuidores",

  solutionsProgram3Title: "Pack de combinacion online",
  solutionsProgram3Body:
    "Sets compactos orientados a visual de PDP y mayor conversión online.",
  solutionsProgram3Item1: "Mini kits",
  solutionsProgram3Item2: "Packs para regalo",
  solutionsProgram3Item3: "Insertos de marca privada",
  solutionsProgram3SuitedFor: "Amazon / e-commerce",

  admin: {
    ...(en.admin || {}),

    // --- categories / faq / company images ---
    productCategoryYogaMats: "Esterillas de yoga",
    productCategoryYogaBlocks: "Bloques de yoga",
    productCategoryYogaStraps: "Correas de yoga",
    productCategoryResistanceBands: "Bandas de resistencia",
    productCategoryPilatesRings: "Aros de pilates",
    productCategoryFoamRollers: "Rodillos de espuma",
    productCategoryOthers: "Otros",

    faqSampleOrderQ: "¿Aceptan pedidos de muestra?",
    faqSampleOrderA:
      "Sí, aceptamos pedidos de muestra. No dudes en contactarnos.",
    faqCustomPackagingQ:
      "¿Ofrecen servicio de empaque personalizado y logotipo?",
    faqCustomPackagingA:
      "Sí, ofrecemos servicios OEM/ODM personalizados.",
    faqLeadTimeQ: "¿Cuál es su plazo de entrega?",
    faqLeadTimeA:
      "Normalmente de 1 a 3 días, dependiendo de la cantidad del pedido. El plazo final se confirmará cuando se realice el pedido.",
    faqDefectiveItemQ: "¿Cómo se maneja un artículo defectuoso?",
    faqDefectiveItemA:
      "Ofrecemos UNA GARANTÍA DE UN AÑO a partir de la fecha de envío. Durante el período de garantía, si tienes un artículo defectuoso debido a nuestros materiales o mano de obra, envíanos los detalles, incluyendo descripción, fotos o video, e incluso una muestra defectuosa cuando sea necesario. Nuestros ingenieros analizarán el caso y te ofrecerán una solución. Si deseas devolverlo, contáctanos y devuelve los artículos con su empaque y accesorios originales. El dinero será reembolsado cuando recibamos los artículos devueltos o enviaremos un reemplazo gratuito.",
    faqWhyChooseUsQ: "¿Por qué elegirnos?",
    faqWhyChooseUsA:
      "Nuestros productos tienen MOQ bajo y alta calidad, capaces de cumplir con estándares de EE. UU. o la UE. Ofrecemos un alto nivel de servicio, aceptamos pedidos OEM y de Trade Assurance. Puedes enviar sin preocupaciones.",

    companyImageSectionOverview: "Resumen de la empresa",
    companyImageSectionAdvantages: "Ventajas competitivas",
    companyImageSectionCustomization: "Capacidades de personalización",
    companyImageSectionExtended: "Perfil ampliado de la empresa",
    companyImageSectionPackaging: "Especificaciones de empaque y envío",
    companyImageSectionFactory: "Perfil de fábrica",
    companyImageSectionWorkflow: "Flujo de producción",
    companyImageSectionTradeShow: "Participación en ferias comerciales",

    // --- order status / tab descriptions ---
    orderStatusPaid: "Pagado",
    orderStatusPacked: "Empacado",
    orderStatusInTransit: "En tránsito",
    orderStatusDelivered: "Entregado",
    orderStatusCancelled: "Cancelado",

    tabDescHome:
      "Gestiona las operaciones de tu espacio de trabajo y supervisa el rendimiento aquí.",
    tabDescStoreBase:
      "Configura los títulos de la tienda/admin y los metadatos SEO.",
    tabDescTemplateStudio: "Edita visualmente los módulos de diseño de la tienda y guarda plantillas personalizadas.",
    tabDescArticleManagement:
      "Gestiona artículos del blog en un espacio dedicado con edición basada en cuadros de diálogo.",
    tabDescCompanyImages:
      "Gestiona recursos de imágenes categorizadas de la empresa para el contenido del perfil de la tienda.",
    tabDescDesignNav:
      "Configura la navegación de la tienda y la estructura de menús anidados.",
    tabDescDesignCarousel:
      "Gestiona las imágenes del carrusel para la sección principal de tu tienda.",
    tabDescDesignBanner:
      "Configura mensajes de banner y contenido de llamada a la acción.",
    tabDescFaqKnowledge:
      "Mantén el contenido FAQ utilizado por los equipos operativos y de ventas.",
    tabDescProducts:
      "Gestiona el catálogo de productos, detalles e información de precios.",
    tabDescProductCreate:
      "Crea un nuevo producto con información completa y medios.",
    tabDescMerchandising:
      "Evalúa productos candidatos, estructura de precios y preparación para lanzamiento.",
    tabDescProcurement:
      "Coordina planes de compra, avance de proveedores y prioridades de abastecimiento.",
    tabDescQuality:
      "Haz seguimiento a puntos de inspección y preparación antes del cumplimiento.",
    tabDescLogistics:
      "Supervisa el estado de los envíos, preparación del empaque y colaboración de seguimiento.",
    tabDescOrders:
      "Haz seguimiento al ciclo de vida del pedido, cumplimiento y actualizaciones de envío.",
    tabDescCustomers:
      "Gestiona aquí los miembros de tu equipo y sus permisos de cuenta.",
    tabDescMarketing:
      "Revisa el estado de campañas y el rendimiento del crecimiento.",
    tabDescDiscounts:
      "Gestiona la estrategia de descuentos y las reglas promocionales.",
    tabDescFinance:
      "Supervisa registros financieros y tendencias de ingresos.",
    tabDescFinanceIncome: "Revisa cobros de pedidos, ingresos reconocidos y registros del libro de ingresos.",
    tabDescFinanceExpenses: "Haz seguimiento a facturas de compras, logística, marketing y gastos de oficina.",
    tabDescFinanceReceivables: "Haz seguimiento a cuentas por cobrar, antigüedad y prioridades de cobranza.",
    tabDescFinancePayables: "Gestiona cuentas por pagar, pagos a proveedores y presiones de vencimiento.",
    tabDescFinanceInvoices: "Mantiene facturas, recibos y estado de facturación.",
    tabDescFinanceTax: "Revisa impuesto repercutido, impuesto soportado y estimaciones fiscales.",
    tabDescFinanceBudget: "Haz seguimiento a presupuestos, asignación de gastos y alertas de exceso.",
    tabDescFinanceDaily: "Resume ingresos, gastos y efectivo neto de la empresa por día.",
    tabDescFinanceMonthly: "Cierra los libros mensuales y revisa ganancias y variación presupuestaria.",
    tabDescFinanceYearly: "Revisa ingresos anuales, gastos, impuestos y utilidad neta.",
    tabDescFinanceReconciliation: "Concilia cuentas por cobrar, cobranzas, cuentas por pagar, facturas y estado fiscal.",
    tabDescFinanceApprovals: "Gestiona auditorías de aprobación de reembolsos, pagos y gastos.",
    tabDescFinanceReports: "Resume estados financieros, métricas operativas y trabajos de exportación.",
    tabDescAnalytics:
      "Analiza información de datos y métricas operativas.",
    tabDescSettings:
      "Gestiona configuraciones del sistema de bajo nivel, como conectividad de base de datos.",
    tabDescWorkTargets:
      "Haz seguimiento y coordina objetivos diarios de trabajo.",
    tabDescWorkProcessing:
      "Gestiona flujos de trabajo asignados y registros de ejecución.",
    tabDescHrEmployee:
      "Visualiza y mantén perfiles de empleados e información de cuentas.",
    tabDescHrRecruitment:
      "Haz seguimiento a la cola de tareas de reclutamiento e incorporación.",
    tabDescHrAttendance:
      "Supervisa asistencia del personal y estado de actividad de cuentas.",
    tabDescHrOffice:
      "Gestiona cobertura de puestos y tareas administrativas internas.",
    tabDescSiteMaintenance:
      "Mantén el contenido de la tienda y la estabilidad del sitio.",
    tabDescPermissionMaintenance:
      "Mantén permisos basados en roles y límites de acceso.",
    tabDescPositionMaintenance: "",
    tabDescProfile: "Revisa la información de tu cuenta.",
    tabDescPassword: "Cambia la contraseña de tu cuenta de forma segura.",
    tabDescInquiry:
      "Contacta al vendedor y continúa la comunicación de consulta.",
    tabDescWishlist:
      "Gestiona productos guardados y artículos preferidos de abastecimiento.",
    tabDescOrderProcessing:
      "Haz seguimiento y procesa registros del ciclo de vida del pedido.",
    tabDescAfterSales:
      "Da seguimiento a solicitudes de posventa y tickets de soporte.",

    // --- roles / menus ---
    roleDeveloper: "Desarrollador",
    roleSuperAdmin: "Súper administrador",
    roleAdmin: "Administrador",
    roleCustomer: "Cliente",
    roleGuest: "Invitado",

    productCreateMenu: "Publicación de producto",
    productsMenu: "Gestión de productos",
    merchandisingOverview: "Resumen de merchandising",
    merchandisingCollection: "Pool recopilado",
    internalOverview: "Resumen y configuración",
    internalWorkspace: "Catálogo y cumplimiento",
    internalBusiness: "Ventas y clientes",
    internalOffice: "Espacio de trabajo por puesto",
    internalMaintenance: "Panel de mantenimiento",
    storefrontContent: "Contenido de la tienda",
    guestService: "Servicios para invitados",
    customerService: "Servicios al cliente",
    commonAccount: "Mi cuenta",
    siteMaintenanceMenu: "Gestión de puestos",
    positionMaintenanceMenu: "Gestión de usuarios",

    title: "Mi tienda",
    home: "Resumen operativo",
    storeDesign: "Configuración de la tienda",
    companyProfile: "Perfil de la empresa",
    storeBase: "Configuración básica de la tienda",
    templateStudio: "Estudio de plantillas",
    articleManagement: "Gestión de artículos",
    companyProfileMenu: "Introducción de la empresa",
    companyImages: "Imágenes de la empresa",
    designNav: "Menú de navegación",
    designCarousel: "Carrusel de inicio",
    designBanner: "Configuración de banner",
    faqKnowledge: "Base de conocimiento FAQ",
    products: "Gestión de productos",
    productCreate: "Crear producto",
    merchandising: "Centro de merchandising",
    procurement: "Centro de compras",
    quality: "Centro de calidad",
    logistics: "Colaboración logística",
    orders: "Consultas y pedidos",
    customers: "Gestión de clientes",
    marketing: "Campañas",
    discounts: "Estrategia de precios",
    finance: "Resumen financiero",
    financeIncome: "Libro de ingresos",
    financeExpenses: "Facturas de gastos",
    financeReceivables: "Cuentas por cobrar",
    financePayables: "Cuentas por pagar",
    financeInvoices: "Gestión de facturas",
    financeTax: "Gestión fiscal",
    financeBudget: "Presupuesto y gastos",
    financeDaily: "Facturas diarias",
    financeMonthly: "Cierre mensual",
    financeYearly: "Estados anuales",
    financeReconciliation: "Conciliación",
    financeApprovals: "Aprobaciones y auditoría",
    financeReports: "Informes y exportación",
    analytics: "Análisis de datos",
    settings: "Configuración del sistema",

    menuCommon: "Común",
    menuInternal: "Interno",
    menuWorkContent: "Contenido de trabajo",
    menuMaintenance: "Panel de mantenimiento",
    userManagementGroup: "Panel de mantenimiento",
    menuGuest: "Invitado",
    menuCustomer: "Cliente",

    workTargets: "Objetivos de tareas",
    workProcessing: "Procesamiento de trabajo",
    hrEmployee: "Perfiles de empleados",
    hrRecruitment: "Reclutamiento",
    hrAttendance: "Asistencia",
    hrOffice: "Administración de oficina",
    siteMaintenance: "Mantenimiento de puestos",
    permissionMaintenance: "Mantenimiento de permisos",
    positionMaintenance: "Gestión de usuarios",
    profile: "Mi perfil",
    password: "Cambiar contraseña",
    inquiry: "Mensajes de consulta",
    wishlist: "Lista de deseos",
    orderProcessing: "Procesamiento de pedidos",
    afterSales: "Servicio posventa",

    // --- profile / password / inquiry ---
    profileCardTitle: "Información personal",
    accountId: "ID de cuenta",
    profileName: "Nombre",
    profileEmail: "Correo",
    profileRole: "Rol",

    passwordCardTitle: "Actualizar contraseña de la cuenta",
    currentPassword: "Contraseña actual",
    adminResetPasswordHint:
      "Esta acción restablece la contraseña del usuario objetivo. No requiere su contraseña actual.",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar nueva contraseña",
    savePassword: "Actualizar contraseña",
    passwordUpdated: "Contraseña actualizada correctamente.",

    inquiryCardTitle: "Comunicación de consulta",
    inquiryCardBody:
      "Contacta al equipo vendedor para hablar sobre requisitos de producto, cotizaciones y planes de entrega.",
    openInquiryCenter: "Abrir página de contacto",
    openWhatsappChat: "Chat de WhatsApp",

    permissionSectionTitle: "Conjunto actual de permisos",
    permissionSectionBody:
      "Los permisos se resuelven desde los datos de inicio de sesión y se asignan según la estructura de tu puesto.",
    placeholderTodo:
      "Este módulo está habilitado para tu puesto. Aquí puedes ampliar acciones comerciales concretas.",

    // --- settings / system / base ---
    systemConfigTitle: "Centro de configuración del sistema",
    settingsTabDatabase: "Base de datos",
    settingsTabDatabaseHint: "Configuración de conexión y pool",
    settingsTabEmail: "Correo",
    settingsTabEmailHint: "Branding y plantillas transaccionales",

    mysqlHost: "Host de MySQL",
    mysqlPort: "Puerto de MySQL",
    mysqlDatabase: "Base de datos MySQL",
    mysqlUser: "Usuario MySQL",
    mysqlPassword: "Contraseña MySQL",
    mysqlPoolSize: "Tamaño del pool MySQL",
    mysqlConnectTimeoutMs: "Tiempo de conexión MySQL (ms)",

    saveSystemConfig: "Guardar configuración del sistema",
    systemConfigSavedToast: "Configuración del sistema guardada",
    systemConfigPathLabel: "Archivo de configuración",
    restartRequiredHint:
      "Reinicia el backend después de guardar para que la nueva configuración de base de datos surta efecto.",

    storefrontTitle: "Título de la tienda",
    adminTitle: "Título del panel de administración",
    seoMetaTitle: "Título meta SEO",
    seoDescription: "Descripción meta SEO",
    seoKeywords: "Palabras clave SEO",
    seoCanonicalUrl: "URL canónica",
    seoRobots: "SEO robots",
    seoOgTitle: "Título Open Graph",
    seoOgDescription: "Descripción Open Graph",
    seoOgImage: "URL de imagen Open Graph",
    seoTwitterCard: "Tipo de tarjeta de Twitter",
    seoTwitterSite: "Cuenta/sitio de Twitter",

    saveBaseSettings: "Guardar configuración básica",
    baseSavedToast: "Configuración básica guardada",

    // --- common ui ---
    hello: "Hola, comencemos.",
    askAnything: "Pregunta lo que quieras...",
    supportLine: "¿Necesitas ayuda? Contacta al soporte",

    addStoreName: "Agregar nombre de la tienda",
    firstProduct: "Agrega tu primer producto",
    firstProductDesc:
      "Empieza agregando un producto y sus detalles clave para prepararlo para la venta.",
    addProduct: "Agregar producto",
    importData: "Importar",

    customizeStore: "Personaliza la tienda online",
    customizeStoreDesc:
      "Elige una plantilla y luego agrega tu logotipo, colores e imágenes.",
    customTemplate: "Plantilla personalizada",
    payments: "Configurar pagos",
    shipping: "Revisar tarifas de envío",
    domain: "Dominio personalizado",

    quickSales: "Simplifica ventas multicanal",
    quickSalesDesc:
      "Gestiona tus listados en distintos marketplaces desde un solo lugar.",

    storeSettings: "Configuración de la tienda",
    general: "General",
    billing: "Facturación",
    usersPermissions: "Usuarios",

    paginationPrevious: "Anterior",
    paginationNext: "Siguiente",
    paginationPage: "Página",
    paginationTotal: "Total",

    policies: "Políticas",
    businessInfo: "Información del negocio",
    contactInfo: "Contacto de la tienda",
    defaults: "Valores predeterminados de la tienda",

    businessMode: "Modo de negocio",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "Modo de tienda actualizado",
    modeSavedToast: "Modo de negocio cambiado correctamente",

    navSettings: "Menú de navegación",
    navLabel: "Nombre del submenú",
    navPath: "Enlace del submenú",
    addSubmenu: "Agregar submenú",
    saveNavigation: "Guardar lista de submenús",
    navSavedToast: "Menú de navegación guardado",

    bannerSettings: "Lista de carrusel",
    bannerTitle: "Título del banner",
    bannerAnnotation: "Anotación de imagen",
    bannerButtonText: "Nombre del botón",
    bannerButtonLink: "Enlace del botón",
    bannerImageUrl: "URL de imagen del banner",
    addBanner: "Agregar banner",
    removeBanner: "Eliminar",
    saveBanners: "Guardar lista de carrusel",
    bannersSavedToast: "Lista de carrusel guardada",

    saveFaqKnowledge: "Guardar base de conocimiento FAQ",
    faqKnowledgeSavedToast: "Base de conocimiento FAQ guardada",
    saveCompanyImages: "Guardar imágenes de la empresa",
    companyImagesSavedToast:
      "Configuración de imágenes de la empresa guardada",

    companyIntroductionTitle: "Introducción de la empresa",
    companyIntroductionHint:
      "Describe el perfil de tu empresa, fortalezas y capacidades de servicio.",
    companyIntroductionPlaceholder:
      "Introduce el contenido de presentación de la empresa...",
    addImageUrl: "Agregar URL de imagen",
    uploadLocalImages: "Subir imágenes locales",
    addFaq: "Agregar FAQ",
    saveCarouselImages: "Guardar imágenes del carrusel",
    carouselImagesSavedToast: "Imágenes del carrusel guardadas",

    close: "Cerrar",
    save: "Guardar",
    create: "Crear",
    search: "Buscar en la pestaña actual",
    refresh: "Actualizar",
    createProduct: "Crear producto",
    cancel: "Cancelar",
    edit: "Editar",
    remove: "Eliminar",

    systemSnapshot: "Instantánea del sistema",
    activeSearch: "Búsqueda en pestaña activa",
    none: "(ninguno)",
    orderRecords: "Registros de pedidos",
    userRecords: "Registros de usuarios",
    lastRefresh: "Última actualización",
    productsCount: "Productos",
    customersCount: "Clientes",
    ordersCount: "Pedidos",
    revenue: "Ingresos USD",

    localeLabel: "Idioma",
    sku: "SKU",
    name: "Nombre",
    description: "Descripción",
    price: "Precio USD",
    imageUrl: "URL de imagen",
    category: "Categoría",
    model: "Modelo",
    titleField: "Título del producto",
    detailVideo: "URL del video de detalle",
    mainImages: "Imágenes principales (6 URLs, una por línea)",
    detailImages: "Imágenes de detalle (URLs, una por línea)",
    parameters: "Parámetros (una por línea: clave:valor)",
    openCreateProduct: "Abrir formulario de detalle del producto",

    id: "ID",
    serialNumber: "N.º",
    userId: "ID de usuario",
    actions: "Acciones",
    email: "Correo",
    role: "Rol",
    username: "Nombre de usuario",
    nickname: "Apodo",
    userRole: "Rol de usuario",
    phone: "Número de teléfono",
    accountStatus: "Estado de la cuenta",
    jobTitle: "Puesto",
    registeredAt: "Fecha de registro",
    lastActiveAt: "Última actividad",
    statusActive: "Activo",
    statusDisactive: "Inactivo",
    permissions: "Permisos",
    position: "Puesto",
    accessSummary: "Acceso",
    positionName: "Nombre del puesto",
    positionKey: "Clave del puesto",
    department: "Departamento",
    addPosition: "Agregar puesto",
    permissionName: "Nombre del permiso",
    permissionKey: "Clave del permiso",
    addPermission: "Agregar permiso",
    editPermissions: "Editar permisos",
    permissionSelectTitle: "Seleccionar permisos",
    permissionSelectedSummary: "Permisos seleccionados",
    permissionQuickSearchPlaceholder:
      "Búsqueda rápida por clave o anotación",
    defaultAdminPosition: "Administrador de operaciones",

    orderId: "Pedido",
    total: "Total",
    status: "Estado",
    cartItems: "Artículos del carrito",
    logout: "Cerrar sesión",
    changePasswordAction: "Cambiar contraseña",
    userPasswordModalTitle: "Restablecer contraseña de usuario",
    userPasswordUpdated: "La contraseña del usuario se actualizó correctamente.",
    targetUser: "Usuario objetivo",
    userDataResyncedHint:
      "Los campos del perfil se resincronizaron desde el servidor después de guardar.",
    userManagementRestrictedHint:
      "Se requiere un permiso de nivel superior para esta operación.",

    capability: {
      ...((en.admin && en.admin.capability) || {}),

      "admin:overview:read": "Ver resumen de administración",
      "admin:products:read": "Ver productos de administración",
      "admin:products:write": "Editar productos de administración",
      "admin:orders:read": "Ver pedidos de administración",
      "admin:orders:write": "Editar pedidos de administración",
      "admin:users:read": "Ver usuarios de administración",
      "admin:users:role:write": "Editar roles de usuario",
      "admin:users:position:assign": "Asignar puestos a usuarios",
      "admin:storefront:read": "Ver configuración de la tienda",
      "admin:storefront:write": "Editar configuración de la tienda",
      "admin:system-config:read": "Ver configuración del sistema",
      "admin:system-config:write": "Editar configuración del sistema",
      "shop:profile:read": "Ver perfil de la tienda",
      "shop:password:write": "Actualizar contraseña de la tienda",
      "shop:orders:read": "Ver pedidos de la tienda",
      "shop:inquiry:write": "Gestionar consultas de la tienda",
      "shop:wishlist:read": "Ver lista de deseos",
      "shop:orders:processing:read": "Ver procesamiento de pedidos",
      "shop:after-sales:read": "Ver posventa",
      "internal:work:targets:read": "Ver objetivos de trabajo",
      "internal:work:processing:read": "Ver procesamiento de trabajo",
      "internal:maintenance:site:write": "Editar mantenimiento del sitio",
      "internal:maintenance:permission:write":
        "Editar mantenimiento de permisos",
      "internal:maintenance:position:write":
        "Editar mantenimiento de puestos",
      "shop:products:read": "Ver productos de la tienda",
      "shop:storefront:read": "Ver tienda",
      "internal:system:config:read":
        "Ver configuración interna del sistema",
      "internal:system:config:write":
        "Editar configuración interna del sistema",
      "internal:security:audit:read": "Ver auditorías de seguridad",
      "internal:security:session:revoke": "Revocar sesiones",
      "internal:integration:manage": "Gestionar integraciones",
      "admin:users:write": "Editar usuarios de administración",
      "admin:users:password:reset":
        "Restablecer contraseñas de usuarios",
      "admin:users:delete": "Eliminar usuarios de administración",
      "crm:customer:read": "Ver registros de clientes",
      "crm:customer:write": "Editar registros de clientes",
      "crm:customer:assign": "Asignar clientes",
      "website:content:read": "Ver contenido del sitio web",
      "website:content:write": "Editar contenido del sitio web",
      "website:navigation:write": "Editar navegación del sitio web",
      "website:banner:write": "Editar banners del sitio web",
      "website:seo:write": "Editar configuración SEO",
      "website:theme:write": "Editar tema del sitio web",
      "website:publish": "Publicar contenido del sitio web",
      "admin:products:create": "Crear productos de administración",
      "admin:products:delete": "Eliminar productos de administración",
      "merchandising:selection:read": "Ver selección de merchandising",
      "merchandising:selection:write":
        "Editar selección de merchandising",
      "catalog:pricing:write": "Editar precios del catálogo",
      "catalog:inventory:write": "Editar inventario",
      "catalog:translation:write": "Editar traducciones del catálogo",
      "sales:inquiry:read": "Ver consultas de ventas",
      "sales:inquiry:reply": "Responder consultas de ventas",
      "sales:quotation:create": "Crear cotizaciones",
      "sales:quotation:approve": "Aprobar cotizaciones",
      "sales:contract:write": "Editar contratos de ventas",
      "sales:sample:manage": "Gestionar muestras",
      "order:status:update": "Actualizar estado del pedido",
      "order:split:merge": "Dividir o fusionar pedidos",
      "procurement:purchase:write": "Editar órdenes de compra",
      "production:plan:write": "Editar planes de producción",
      "qa:inspection:write": "Editar inspecciones de calidad",
      "logistics:shipment:write": "Editar registros de envíos",
      "logistics:tracking:read": "Ver seguimiento de envíos",
      "trade:customs:doc:write": "Editar documentos aduaneros",
      "finance:invoice:read": "Ver facturas",
      "finance:invoice:write": "Editar facturas",
      "finance:payment:read": "Ver pagos",
      "finance:payment:write": "Editar pagos",
      "finance:refund:approve": "Aprobar reembolsos",
      "finance:reconciliation:write":
        "Editar registros de conciliación",
      "finance:tax:write": "Editar configuración fiscal",
      "marketing:campaign:read": "Ver campañas de marketing",
      "marketing:campaign:write": "Editar campañas de marketing",
      "marketing:coupon:write": "Editar cupones",
      "marketing:lead:export": "Exportar leads",
      "analytics:dashboard:read": "Ver panel analítico",
      "analytics:report:export": "Exportar informes analíticos",
      "support:ticket:read": "Ver tickets de soporte",
      "support:ticket:write": "Editar tickets de soporte",
      "support:return:approve": "Aprobar devoluciones",
      "support:complaint:handle": "Gestionar reclamaciones",
      "office:announcement:write": "Publicar anuncios",
      "office:document:read": "Ver documentos de oficina",
      "office:document:write": "Editar documentos de oficina",
      "office:workflow:approve": "Aprobar flujos de trabajo de oficina",
      "office:meeting:manage": "Gestionar reuniones",
      "hr:employee:read": "Ver perfiles de empleados",
      "hr:employee:write": "Editar perfiles de empleados"
    }
  },
  blogReadingTimeMin: "min de lectura",
  blogShowLess: "Mostrar menos",
  requestFreeSample: "Solicitar muestra gratis",
  factoryStatsSince: "Desde 1995",
  factoryStatsCapacity: "Mas de 10.000 unidades al mes",
  factoryStatsExport: "Exportacion a mas de 50 paises",
  factoryStatsCert: "Certificacion ISO 9001 y BSCI",
  aboutAddress: "Direccion: Edificio Ruihe Kechuang, Wanglong Road, Distrito Yuelu, Changsha, Hunan, China",
  aboutTeamTitle: "Equipo dinamico y profesional",
  aboutTeamBody: "Somos un equipo joven y experimentado, con profundo entendimiento de la demanda del mercado y de los detalles tecnicos de la industria del yoga. Con criterios rigurosos de seleccion y respuesta eficiente, garantizamos que cada entrega cumpla altos estandares comerciales.",
  aboutCustomizationTitle: "Servicios integrales de personalizacion",
  aboutCustomizationBody: "Desde impresion de logotipo y diseno de empaque hasta desarrollo de moldes funcionales, ofrecemos soluciones de personalizacion flexibles y profundas para ayudar a que tu marca destaque en el mercado.",
  aboutFactoryPartnerTitle: "Socios de fabrica de alta calidad",
  aboutFactoryPartnerBody: "Trabajamos estrechamente con bases de fabricacion certificadas por ISO/BSCI, controlando la calidad desde el origen para asegurar produccion estable y entregas puntuales.",
  oemServiceShowcaseAria: "Servicios de personalizacion OEM y ODM",
  oemServiceShowcaseTitle: "Servicios de personalizacion OEM y ODM",
  oemServiceShowcaseBody: "Soporte integral y flexible, desde la evaluacion del concepto hasta la produccion y la entrega.",
  oemCompareHeadBody: "Cuatro rutas habituales, comparando version base y resultado personalizado.",
  oemCompareBaseSuffix: "version base",
  oemCompareOptionsSuffix: "opciones de personalizacion",
  oemCompareCustomizedSuffix: "version personalizada",
  oemCompare1Title: "Aplicacion de logotipo",
  oemCompare1Body: "De producto basico a presentacion de marca.",
  oemCompare1BeforeLabel: "Base",
  oemCompare1AfterLabel: "Con logotipo",
  oemCompare1CustomizationLabel: "Anadido de logotipo",
  oemCompare1Item1: "Impresion",
  oemCompare1Item2: "Relieve",
  oemCompare1Item3: "Marcado laser",
  oemCompare2Title: "Color y acabado",
  oemCompare2Body: "De especificacion neutra a color adaptado al mercado.",
  oemCompare2BeforeLabel: "Estandar",
  oemCompare2AfterLabel: "Color personalizado",
  oemCompare2CustomizationLabel: "Actualizacion de color",
  oemCompare2Item1: "Color",
  oemCompare2Item2: "Textura",
  oemCompare2Item3: "Tamano",
  oemCompare3Title: "Configuracion de empaque",
  oemCompare3Body: "De empaque simple a presentacion lista para venta minorista.",
  oemCompare3BeforeLabel: "Empaque simple",
  oemCompare3AfterLabel: "Listo para minorista",
  oemCompare3CustomizationLabel: "Detalles de empaque",
  oemCompare3Item1: "Tarjeta interior",
  oemCompare3Item2: "Codigo de barras",
  oemCompare3Item3: "Marcado de caja",
  oemCompare4Title: "Desarrollo de combinaciones",
  oemCompare4Body: "De articulos sueltos a sets listos para canal.",
  oemCompare4BeforeLabel: "Articulos sueltos",
  oemCompare4AfterLabel: "Set combinado",
  oemCompare4CustomizationLabel: "Logica de combinacion",
  oemCompare4Item1: "Set para estudio",
  oemCompare4Item2: "Pack para Amazon",
  oemCompare4Item3: "Mezcla promocional",
  oemCasesTitle: "Casos de personalizacion",
  oemCase1Title: "Linea inicial para estudio boutique",
  oemCase1Summary: "Presentacion de kit inicial para lanzamiento de estudio boutique.",
  oemCase1Details: "Kit con logotipo aprobado en 12 dias.",
  oemCase2Title: "Renovacion de marca privada para venta minorista",
  oemCase2Summary: "Actualizacion visual del empaque para una presencia mas limpia en estanteria.",
  oemCase2Details: "Aprobacion del comprador mas rapida y mayor consistencia en venta minorista.",
  oemCase3Title: "Paquete fitness listo para marketplace",
  oemCase3Summary: "Configuracion de paquete preparada para e-commerce y fichas de producto.",
  oemCase3Details: "Inserto, codigo de barras y revision para produccion masiva listos.",
  oemOrderingFlowKicker: "Flujo de pedido",
  oemOrderingFlowTitle: "Contacto y pedido en cinco pasos",
  oemContactFlow1: "Consulta inicial con lista de productos, mercado destino y requerimientos de marca.",
  oemContactFlow2: "Cotizacion con plan de muestras, plazo de entrega y opciones de empaque.",
  oemContactFlow3: "Confirmacion de muestra y aprobacion de detalles del pedido.",
  oemContactFlow4: "Deposito, produccion, inspeccion y reserva de envio.",
  oemContactFlow5: "Pago del saldo, documentos de exportacion y seguimiento posventa.",
  oemContactSideTitle: "Listo para hablar de tu solicitud OEM?",
  oemContactSideBody: "Envia tu logotipo, cantidad objetivo e idea de empaque. Te responderemos con una ruta de cotizacion practica y recomendacion de muestras.",
  oemContactSideNote: "Canal de primer contacto recomendado: email o formulario de consulta con arte y ventana de envio prevista.",
  oemContactSideCta: "Contactar al equipo comercial",
  requestQuote: "Solicitar cotizacion",
  trustTitle: "Socios globales y confianza",
  factoryStatsSize: "Fabrica de 30.000 m2",
  factoryStatsQC: "100% control de calidad en linea y final",
  homeAriaTrust: "Confianza y socios",
  homeAriaStats: "Datos y capacidad de fabrica",
};
